import { css } from '@emotion/core';
import MediaQueries from '../../../styles/Grid/MediaQueries';
import { typography, fontWeights } from '../../../styles/typography';
import { colorsPalette } from '../../../styles/colors';

const focusActiveCss = {
  color: colorsPalette.black,
  fontSize: 12,
  fontWeight: fontWeights.medium,
  '&:after': {
    content: '""',
  },
};

export const containerPaddingCss = {
  padding: '96px 0',
  [MediaQueries.lgAndUp]: {
    paddingBottom: 120,
  },
};

export const containerMarginCss = {
  margin: '96px 0',
  [MediaQueries.lgAndUp]: {
    marginBottom: 120,
  },
};

export const spacerCss = css({
  overflow: 'hidden',
});

export const headlineCss = css(typography.effra48, {
  fontWeight: fontWeights.medium,
  position: 'relative',
  marginBottom: 32,
  [MediaQueries.lgAndUp]: {
    marginBottom: 40,
  },
});

export const itemTabCss = css({
  cursor: 'pointer',
  flex: '0 0 auto',
  marginRight: 40,
  textAlign: 'left',
  [MediaQueries.mdAndUp]: {
    flex: 1,
    marginRight: 0,
  },
});

export const textHeaderCss = css(typography.effra12Link, {
  pointerEvents: 'none',
  display: 'inline-block',
  position: 'relative',
  height: '100%',
  cursor: 'pointer',
  color: colorsPalette.grey60,
  fontWeight: fontWeights.medium,
  '&:after': {
    position: 'absolute',
    bottom: '-3px',
    left: 0,
    width: '100%',
    height: 1,
    borderBottom: `2px solid ${colorsPalette.red} `,
  },
  '&[data-active="true"]': focusActiveCss,
});

export const contentTabItemCss = css({
  display: 'none',
  '&[data-active="true"]': {
    display: 'block',
  },
});

export const contentHeadlineCss = css(typography.effra69, {
  fontWeight: fontWeights.medium,
  marginBottom: 32,
  [MediaQueries.md]: {
    marginBottom: 48,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 32,
  },
});

export const contentDescriptionCss = css(typography.effra18, {
  [MediaQueries.sm]: {
    fontSize: 16,
  },
  color: colorsPalette.grey60,
});

export const tabsContentCss = css({
  marginTop: 40,
  [MediaQueries.md]: {
    marginTop: 60,
  },
  [MediaQueries.lgAndUp]: {
    marginTop: 62,
  },
});

export const ctaLinkCss = css({
  marginTop: 19,
  [MediaQueries.md]: {
    marginTop: 33,
  },
  [MediaQueries.lgAndUp]: {
    marginTop: 20,
  },
});

export const tabsHeaderCss = css({
  boxShadow: 'none',
});

export const TabCtaCss = css({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  outline: 'none',
  padding: '10px 0',
  textAlign: 'left',
  width: '100%',
  '&:focus': {
    span: focusActiveCss,
  },
});

export const pictureStyles = css({
  width: '100%',
  height: '100%',
});

export const imageStyles = css({
  width: '100%',
  height: '100%',
  display: 'block',
});
